import {Component, OnInit, OnDestroy, AfterViewInit, Inject, HostListener} from '@angular/core';
import {NotificationService, ToasterPopupService} from '@serengeti/serengeti-notification';
import {LoginService} from '@serengeti/serengeti-common';
import {TranslateService} from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';
import {environment} from 'src/environments/environment';
import {AppConfigService} from './app-config.service';
import {HistoryService} from '@serengeti/serengeti-resource';
import {MenuService} from '@serengeti/serengeti-menu';
import {ThemeService} from './setting/theme/service/theme.service';
import {CodeService} from '@serengeti/serengeti-code';
import {ToasterConfig} from 'angular2-toaster';
import { Data, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { OrderRequestService } from '@serengeti/serengeti-order';
import { NavigationService } from './layout/navigation/navigation.service';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-root',
  template: `
    <button mat-mini-fab color="disabled" class="toaster-button-container" *ngIf="toasterPopupService.toasterCheck"
            (click)="toasterPopupService.deleteAll()">
      <mat-icon>close</mat-icon>
    </button>
    <toaster-container [toasterconfig]="config" class="custom-toast"></toaster-container>
    <router-outlet></router-outlet>
  `,
})
export class AppRootComponent implements OnInit, AfterViewInit, OnDestroy {

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    sessionStorage.setItem('reload', 'true');
  }

  public config: ToasterConfig = new ToasterConfig({
    positionClass: 'toast-top-right',
    animation: 'fade',
    mouseoverTimerStop: true,
    timeout: 15000,
    titleClass: 'toast-title',
    typeClasses: {
      error: 'toast-error',
      info: 'toast-info',
      wait: 'toast-wait',
      success: 'toast-success',
      warning: 'toast-warning',
      major: 'toast-major',
      minor: 'toast-minor',
      indeterminate: 'toast-indeterminate'
    },
    iconClasses: {
      error: 'icon-error',
      info: 'icon-info',
      wait: 'icon-wait',
      success: 'icon-success',
      warning: 'icon-warning',
      major: 'icon-major',
      minor: 'icon-minor',
      indeterminate: 'icon-indeterminate'
    }
  });
  isMenuCollapsed = false;

  profile: string;

  routerSubject: Subject<string> = new Subject<string>();

  constructor(
    private translateService: TranslateService,
    private requestService: OrderRequestService,
    private loginService: LoginService,
    private notificationService: NotificationService,
    private translate: TranslateService,
    private titleService: Title,
    private codeService: CodeService,
    private historyService: HistoryService,
    private menuService: MenuService,
    private themeService: ThemeService,
    private appConfigService: AppConfigService,
    private navigateService: NavigationService,
    public router: Router,
    public toasterPopupService: ToasterPopupService,
    @Inject(DOCUMENT) private _document: HTMLDocument
    ) {

    this.profile = environment.profile;
    (window as any).routerSubject = this.routerSubject;

    this._loadImages();
  }

  ngOnInit() {
		if (this.profile === 'dpg') {
      if (!sessionStorage.getItem('reload')) {
        if (localStorage.getItem('serengetiSession')) {
          localStorage.removeItem('serengetiSession');
        }
      }
			this._document.getElementById('appFavicon').setAttribute('href', 'assets/images/logo/dpg/dpg_logo.png');
		} else if (this.profile === 'prod') {
			this._document.getElementById('appFavicon').setAttribute('href', 'assets/images/logo/dev/logo_Serengeti_Symbol.svg');
    }

    this.routerSubject.subscribe((routeConfig: any) => {
      if (routeConfig.navigate) {
        this.navigateService.handleNavigationData(routeConfig.navigate.path, routeConfig.navigate.data as Data);
      }
      if (routeConfig.order) {
        this.translateService.get([
          'lib.order.request.dialog.alert.invalid-form',
          'lib.order.request.dialog.alert.requested',
          'lib.order.request.dialog.alert.request-failed'
        ]).subscribe((messages: any) => {
          this.requestService.create(routeConfig.order, [])
          .subscribe((requestedOrder: any) => {
            alert(messages['lib.order.request.dialog.alert.requested']);
            if (routeConfig.contentPath) {
              this.router.navigate(['/' + routeConfig.rootPath, { outlets: { content: routeConfig.contentPath }}]);
            } else {
              this.router.navigate(['/' + routeConfig.rootPath]);
            }
          }, () => {
            alert(messages['lib.order.request.dialog.alert.request-failed']);
          });
        });
      } else {
        if (routeConfig.contentPath) {
          this.router.navigate(['/' + routeConfig.rootPath, { outlets: { content: routeConfig.contentPath }}]);
        } else if (routeConfig.rootPath) {
          this.router.navigate(['/' + routeConfig.rootPath]);
        }
      }
    });

    const isKeycloakUsed: string = (environment['isKeycloakUsed'] === "true") ? 'true' : 'false';
    localStorage.setItem("isKeycloakUsed", isKeycloakUsed);
    const loadedSession = this.loginService.loadLoginSession();
    if (loadedSession) {
      environment.content = this.loginService.getScreenConfig('login', 'profile');

      if (!this.notificationService.connected) {
        this.notificationService.connect(loadedSession.loginId);
      }
      this.translate.use(loadedSession.locale);
      this.codeService.find('SystemProfile', environment.profile).subscribe((profileContent: any) => {
        try {
          environment.content = JSON.parse(profileContent.detailInfo);
          if (environment.content && environment.content.themeConfig) {
            this.themeService.themeConfig = environment.content.themeConfig;
          }
          this.themeService.changeTheme(this.themeService.getTheme());
          this.loginService.setScreenConfig('login', 'profile', environment.content);

          this.historyService.count().subscribe(count => {
            this.appConfigService.numberOfNotification = count;
          });
          this.menuService.roots().subscribe(menus => {
            this.appConfigService.menus = menus;
          });
        } catch (error) {
          console.log(error);
        }
      });

      this.loginService.checkTimeout();
    } else {
      this.themeService.changeTheme(this.themeService.getTheme());
    }

    this.translate.get('home.title.' + environment.profile).subscribe((title: string) => {
      this.titleService.setTitle(title);
    });
  }

  ngOnDestroy(): void {
    this.routerSubject.unsubscribe();
  }

  public ngAfterViewInit(): void {
  }

  private _loadImages(): void {
  }

}
